export const FEED_STATS_GROUPINGS = [
  'action_type',
  'importance',
  'made_by',
  'routine',
  'seen_for',
  'week',
  'position',
  'list_size',
  'surface',
] as const;

export type FeedStatsGrouping = (typeof FEED_STATS_GROUPINGS)[number];

// The cards a feed list showed under one value of the grouping, and what their users did with them
export type FeedStatsRow = {
  // null for cards that have no importance. A week is the date of its Monday
  group: string | number | null;
  impressions: number;
  cards: number;
  acted_on: number;
  dismissed: number;
  // Cards whose action ran and failed, from the user's approval or the agent's
  run_failed: number;
  // The showings that reported their time on screen
  timed_impressions: number;
  // null when none did
  median_seen_ms: number | null;
  // Those showings counted in each band of time on screen
  seen_ms_by_band: number[];
  // From a card's creation to its close, or to now while it is open
  median_open_ms: number | null;
  // The cards counted in each band of time open, the closed ones apart from those still open
  closed_by_band: number[];
  still_open_by_band: number[];
};

// The UTC days as YYYY-MM-DD, both counted, and part of a user's email or an ID. An empty field does not filter
export type FeedStatsFilters = {
  start: string;
  end: string;
  user: string;
};
